// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Zx:hover{background:var(--background_button_text) !important}.ay{background:var(--background_button_text) !important}.by:hover{background:rgba(0,0,0,0) !important}", "",{"version":3,"sources":["webpack://./src/components/SecondaryButton/SecondaryButton.module.scss"],"names":[],"mappings":"AAEA,UACE,mDAAA,CAGF,IACE,mDAAA,CAGF,UACE,mCAAA","sourcesContent":["@import \"../../themeStyles/variables\";\r\n\r\n.defaultClass:hover {\r\n  background: $background_green !important;\r\n}\r\n\r\n.active {\r\n  background: $background_green !important;\r\n}\r\n\r\n.disabledBtn:hover {\r\n  background: transparent !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"defaultClass": "Zx",
	"active": "ay",
	"disabledBtn": "by"
};
export default ___CSS_LOADER_EXPORT___;
